import React, { Component } from 'react';
import Appbar from '.';
import { connect } from 'react-redux';
import { SchoolInformationActions, UserProfileActions } from '../../../store'
class AppbarContainer extends Component {
    state = {
        anchorEl: null,
        anchorElForHelp: null
    };

    onClick = event => {
        this.setState({ anchorEl: event.currentTarget })
    }
    onClickOfHelp = event => {
        this.setState({ anchorElForHelp: event.currentTarget })
    }
    handleClose = () => {
        this.setState({ anchorEl: null, anchorElForHelp: null })
    }
  
    render() {
        
        return (
            <Appbar {...this.props}
                onClickOfHelp={this.onClickOfHelp}
                anchorElForHelp={this.state.anchorElForHelp}
                onClick={this.onClick} isMenuOpen={this.state.anchorEl} handleClose={this.handleClose} />
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setActiveProfileType:(profileType) => dispatch(UserProfileActions.setActiveProfileType(profileType)),
        setActiveSchool: (school) => dispatch(SchoolInformationActions.setActiveSchool(school)),
        setIsCreateNewSchool :(isCreatenewSchool) => dispatch(SchoolInformationActions.setIsCreateNewSchool(isCreatenewSchool)),
        updateUserActiveSchool:(ownerId,email,activeSchool,profileType) => dispatch(UserProfileActions.updateUserActiveSchool(ownerId,email,activeSchool,profileType)),
        getSchoolInformationById:(schoolId)=>dispatch(SchoolInformationActions.getSchoolInformationById(schoolId))
    }
}

const mapStateToProps = (state) => {
    return {
        cognitoUser: state.cognito.user,
        userInformation: state.userProfile.userInformation,
        activeProfileType:state.userProfile.activeProfileType
    }
}
export default (connect(mapStateToProps, mapDispatchToProps)(AppbarContainer));


